export enum AuthenticationUserJourneyType {
  ASK_EMAIL_FIRST = 'ASK_EMAIL_FIRST',
  ASK_LOGIN_OR_SIGNUP = 'ASK_LOGIN_OR_SIGNUP',
}
